<script>
    export let data_versions = [];
    export let tag_versions = [];

    let selectedData; // { value, label}
    let selectedTag; // { value, label}
    let createTagLoading = false;
    let createTagResponse;

    import FilenameSelector from "../../components/FilenameSelector.svelte";
    import SectionButton from "../../components/SectionButton.svelte";
    import SectionTitle from "../../components/SectionTitle.svelte";
    import ResultMessage from "../../components/ResultMessage.svelte";
    import { navigate } from "svelte-navigator";
    import { createEventDispatcher, getContext } from "svelte";
    import { api_info, fetchWithAuthentication } from "../../api/client.js";
    const context = getContext(api_info);
    const dispatch = createEventDispatcher();

    async function createTag() {
        if (selectedData) {
            createTagResponse = undefined;
            createTagLoading = true;
            createTagResponse = await fetchWithAuthentication(
                context,
                "/create_tags/",
                {
                    data_collection_name: selectedData.value,
                }
            );
            createTagLoading = false;
            if (createTagResponse.status === true) {
                // notify parent to refresh tag lists
                dispatch("new_tag");
            }
        }
    }

    function editTag() {
        if (selectedTag) {
            navigate(
                `/rearrange_tags?tag=${encodeURIComponent(selectedTag.value)}`
            );
        }
    }
</script>

<h3>2. ป้ายกำกับ</h3>
<form class="form-horizontal">
    <SectionTitle title="สร้างป้ายกำกับ" />
    <FilenameSelector
        label="ข้อมูลคำร้อง"
        id="section2_request"
        items={data_versions}
        bind:value={selectedData}
    />
    <SectionButton
        label="สร้าง"
        disabled={!selectedData}
        loading={createTagLoading}
        on:click={createTag}
    >
        <ResultMessage response={createTagResponse} />
    </SectionButton>

    <SectionTitle title="แก้ไขกลุ่มป้ายกำกับ" />
    <FilenameSelector
        label="ป้ายกำกับ"
        id="section2_tag"
        items={tag_versions}
        bind:value={selectedTag}
    />
    <SectionButton label="แก้ไข" disabled={!selectedTag} on:click={editTag} />
</form>
